import React from 'react';

import { IPlacementInfo } from 'src/components/ListOfLayoutApartments/types';
import { IFilterIconsAndShortInfo } from 'src/typings/filter';
import { UseNumberFormat, useTranslations } from 'src/hooks';
import { useGenerateShowingInfo } from '../../hooks';
import { useStyles } from './styles';

export const InfoIcon: React.FC<IPlacementInfo> = ({
  itemData,
  filterConfigurator,
  displayedType,
}) => {
  const styles = useStyles({});
  const { getTranslations } = useTranslations();
  const renderItems: { [key: string]: IFilterIconsAndShortInfo | any } = useGenerateShowingInfo(filterConfigurator[displayedType], itemData);
  const { numberSeparator, replaceFraction } = UseNumberFormat();

  return (
    <div className={styles.apartmentIconInfo}>
      {Object.keys(renderItems).map((renderItem) => {
        const renderData = renderItems[renderItem];
        const placementData = itemData[renderItem];

        if (itemData[renderItem]) {
          return (
            <div
              key={renderItem}
              className={styles.iconInfo}
            >
              {renderData.icon_url && <img alt="icon" src={`${renderData.icon_url}`} />}
              <span className="iconInfoText">
                {`${renderData['value-prefix'] ? renderData['value-prefix'] : ''} `}
                {renderData['use-name'] && `${getTranslations(renderItem)}`}
                {` ${numberSeparator(replaceFraction(String(getTranslations(placementData))), renderItem)} `}
                {`${renderData['value-sufix'] ? renderData['value-sufix'] : ''}`}
              </span>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};
